export default "__VITE_ASSET__C76pEuD8__"